import { createSlice } from '@reduxjs/toolkit';

import {
  VARIAVEIS_ANDAMENTO,
  type ModeloAndamento,
  type ModelosAndamentoState,
} from '../types/modeloAndamentoTypes';

import {
  alternarStatusModeloAndamento,
  atualizarModeloAndamento,
  criarModeloAndamento,
  listarModelosAndamento,
  listarVariaveisAndamento,
} from './actions';

const initialState: ModelosAndamentoState = {
  modelos: [],
  variaveis: VARIAVEIS_ANDAMENTO,
  isLoading: false,
  isSaving: false,
  error: null,
};

const upsert = (state: ModelosAndamentoState, modelo: ModeloAndamento) => {
  const index = state.modelos.findIndex((item) => item.id === modelo.id);
  if (index !== -1) {
    state.modelos[index] = modelo;
  } else {
    state.modelos.push(modelo);
  }
};

const modelosAndamentoSlice = createSlice({
  name: 'modelosAndamento',
  initialState,
  reducers: {
    clearModelosAndamentoError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarModelosAndamento.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarModelosAndamento.fulfilled, (state, action) => {
        state.isLoading = false;
        state.modelos = action.payload;
      })
      .addCase(listarModelosAndamento.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(criarModeloAndamento.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(criarModeloAndamento.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(criarModeloAndamento.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload as string;
      })

      .addCase(atualizarModeloAndamento.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(atualizarModeloAndamento.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(atualizarModeloAndamento.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload as string;
      })

      .addCase(alternarStatusModeloAndamento.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(alternarStatusModeloAndamento.rejected, (state, action) => {
        state.error = action.payload as string;
      })

      .addCase(listarVariaveisAndamento.pending, (state) => {
        state.error = null;
      })
      .addCase(listarVariaveisAndamento.fulfilled, (state, action) => {
        state.variaveis = action.payload;
      })
      .addCase(listarVariaveisAndamento.rejected, (state, action) => {
        state.error = action.payload as string;
      });
  },
});

export const { clearModelosAndamentoError } = modelosAndamentoSlice.actions;

export default modelosAndamentoSlice.reducer;
